<template>
  <div>
    <app-bar :contract="contract">
      <template v-slot:extension>
        <v-tabs v-model="tab" centered>
          <v-tab
            v-for="(item, index) in menuLinks"
            :key="index"
            @click="handleTabClick(item)"
          >{{ $t(`menuHeaders.${item.name}`)}}</v-tab>
        </v-tabs>
      </template>
    </app-bar>
    <router-view :contract="contract" />
  </div>
</template>

<script>
export default {
  name: 'ContractMain',
  props: {
    contract: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dirty: 0
    }
  },
  async mounted () {
    this.$eventBus.$on('SET_DIRTY', () => this.dirty++)
    this.$eventBus.$on('UNSET_DIRTY', () => this.dirty--)
  },
  computed: {
    menuLinks () {
      return this.contract.id
        ? this.$router.options.routes
          .find((r) => r.name === 'contractMain')
          .children.filter(
            (i) => i.show && (this.contract.isParent ? i.showForParent : true)
          )
        : []
    },
    matchedRouteNames () {
      const matched = this.$route.matched.map((i) => i.name)
      matched.shift()
      return matched
    },
    tab: {
      get () {
        return this.menuLinks.findIndex((i) =>
          this.$route.matched.map((i) => i.name).includes(i.name)
        )
      },
      set () {}
    }
  },
  methods: {
    handleTabClick (item) {
      const prevTab = this.tab
      if (this.dirty > 0) {
        this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
          scope: {
            message: this.$t('contract.unsavedChanges')
          },
          handlers: {
            no: () => {
              this.$nextTick(() => {
                this.tab = prevTab
              })
            },
            yes: async () => {
              this.dirty = 0
              this.prevTab = null
              this.$route.name !== item.name &&
                this.$router.push({
                  name: item.name,
                  params: { contractId: this.$route.params.contractId }
                })
            }
          }
        })
      } else {
        this.$route.name !== item.name &&
          this.$router.push({
            name: item.name,
            params: { contractId: this.$route.params.contractId }
          })
      }
    }
  }
}
</script>

<style>
.app-bar .v-toolbar__content {
  justify-content: end;
}
</style>
